/* eslint-disable import/no-unresolved */
import AuditLogsColumnConfig from 'views/Rules/common/AuditLogsColumnConfig';
import FFIEC041AduitLog from '../components/FFIEC041AduitLog';

const FFIEC041AduitLogs = ({ data }) => {
    const ffiec041Columns = AuditLogsColumnConfig;

    return (
        <FFIEC041AduitLog
            data={data}
            columns={ffiec041Columns}
        />
    );
};

export default FFIEC041AduitLogs;
